export default {
    url: '/employee',
    template: `
        <courses-courses-edit-occurrence-automated-planning-group-add-employee
            planning-group="vm.planningGroup"
        />
    `,
    controller ($scope) {
        $scope.$parent.vm.step = 3;
        this.planningGroup = $scope.$parent.vm.planningGroup;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/automated/add/employee/index.js